import Notifications from 'react-notification-system-redux';
import { Messages } from './model';
import { nodeTreeListeners } from '@myua/nodetree';

export const onOpenError: nodeTreeListeners.OnOpenError = (node, dispatch) => {
  dispatch(Notifications.error(Messages.loadNodesError(node.name)));
};
